import React, { memo } from 'react'

import { array } from 'prop-types'

function AdvancedSettingsContent({ items }) {
  return (
    <div className="advanced-settings__content">
      {items.map((item) => (
        <item.component key={item.id} />
      ))}
    </div>
  )
}

AdvancedSettingsContent.propTypes = {
  items: array.isRequired,
}

export default memo(AdvancedSettingsContent)
